import { TaskInfo } from "../TaskWrap";
import remainingCapacityIcon from "../../../../../../../assets/images/remainingCapacity.svg";
import CalendarIcon from "../../../../../../../assets/images/calendar.svg";
import ClockIcon from "../../../../../../../assets/images/clock.svg";
import SessionTypeIcon from "../../../../../../../assets/images/field.svg";
import DifficultyLevelIcon from "../../../../../../../assets/images/difficulty.svg";
import SnacksIcon from "../../../../../../../assets/images/snacks.svg";


import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";
import { IconFaculty } from "../../../../../Icons/Icons";

interface TaskInfoTagsProps {
    taskInfo: TaskInfo[];
    language: string;
    isClassFull: boolean;
}

const ICONS: Record<string, string | null> = {
    remainingCapacity: remainingCapacityIcon,
    startDate: CalendarIcon,
    time: ClockIcon,
    sessionType: SessionTypeIcon,
    difficultyLevel: DifficultyLevelIcon,
    snacks: SnacksIcon,
};

const sortTaskInfo = (taskInfo: TaskInfo[]) => {
    return taskInfo.sort((a, b) => a.order - b.order);
}

const isFaculty = (name: string): boolean => {
    return name.startsWith('faculty_');
};

const TaskInfoTags = ({ taskInfo, language, isClassFull }: TaskInfoTagsProps) => {
    const [t] = useTranslation(language);

    return (
        <div className={`${styles.infoTags} ${isClassFull ? styles.full : ""}`}>
            {sortTaskInfo(taskInfo).map(({ name, value }) => {
                if (value === undefined || value === null) return null;

                const icon = ICONS[name] || null;
                const text = name === "remainingCapacity"
                    ? t("seatsRemaining", { count: Number(value) > 0 ? Number(value) : 0 })
                    : value;

                return (
                    <div key={name} className={`${styles.info} ${name === "remainingCapacity" ? styles.remainingCapacity : ""}`}>
                        {icon && <img src={icon} alt={name} className={styles.icon} />}
                        {isFaculty(name) && (
                            <IconFaculty
                                strokeWidth={isClassFull ? 1 : 2}
                                style={{ color: isClassFull ? "#4D4D4D" : "#001F4C" }}
                            />
                        )}
                        <span className={`${styles.infoText}
                         ${name === "remainingCapacity" && Number(value) > 0 ? styles.remainingCapacityText : ""}`}
                            style={name === "time" ? { direction: "ltr" } : undefined}>
                            {text}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

export default TaskInfoTags;